import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

const CenterPanelUpdate = ({ isAdmin, setCurrentCheckboxValue, currentCheckboxValue, updateOrView }) => {
  const handleOnChange = (event, data) => {
    if (updateOrView !== 'view') {
      setCurrentCheckboxValue(!currentCheckboxValue);
    }
  };
  return (
    <span>
      <div className={isAdmin == true ? 'ui form minHeightLargerForm' : 'ui form minHeightForm'}>
        <span>{htmlToReactParser.parse(xss(APP.LANGUAGE.Recording.BodyMessage))}</span>
        <div className="ui labeled button display-flex center-flex mrts" id="device-enable-check-session">
          <div className="toggle-box mrrs" onClick={handleOnChange}>
            <div className="toggle-text text-size-ms">
              {currentCheckboxValue ? APP.LANGUAGE.Recording.ON : window.APP.LANGUAGE.Recording.OFF}
            </div>
            <Checkbox toggle checked={currentCheckboxValue} disabled={updateOrView == 'view' ? true : false} />
          </div>
          <div
            style={{ visibility: currentCheckboxValue ? 'visible' : 'hidden' }}
            className="ui no-bold title-sms pdtsss pdbxxs pdrnull txt-left checkBoxTextlhxx"
          >
            {APP.LANGUAGE.Recording.RecordingEnabledMessage}
          </div>
        </div>
      </div>
    </span>
  );
};

export default CenterPanelUpdate;
